import { Card, Col, Row } from 'reactstrap';

import { CertificateFormDataLoader } from './loaders/CertificateFormDataLoader';
import { CertificateOffersLoader } from './loaders/CertificateOffersLoader';
import { CertificatesCards } from './parts/CertificatesCards';
import { CertificatesSearch } from './parts/CertificatesSearch';

export function Certificates() {
  return (
    <Card className="p-4 mt-2 mx-3">
      <CertificateFormDataLoader fetchImmediately>
        <CertificateOffersLoader
          defaultQuery={{ page: 1, items_per_page: 12 }}
          fetchImmediately
        >
          <Row>
            <Col xs={12}>
              <CertificatesSearch />
            </Col>
            <Col xs={12}>
              <CertificatesCards />
            </Col>
          </Row>
        </CertificateOffersLoader>
      </CertificateFormDataLoader>
    </Card>
  );
}
